import { useState, useRef } from "react";
import FormFieldInput from "../ui/FormFieldInput";
import FormFieldTextarea from "../ui/FormFieldTextarea";
import LoadingSpinner from "../ui/LoadingSpinner";
import { useResponseMessages } from "../../hooks/useResponseMessage";

const SupportPHPMailer = () => {
    const formRef = useRef(null);
    const [isSending, setIsSending] = useState(false);
    const [supportFormData, setSupportFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const { addMessage } = useResponseMessages();

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = document.getElementById('supportForm');

        setIsSending(true);

        const formData = new FormData(form);
        formData.append('submit', 'true');

        fetch(`/supportform.php`, {
            method: 'POST',
            body: formData
        }).then(response => {
            if (response.ok) {
                formRef.reset();

                addMessage({
                    data: 'Your message has been sent. We will get back to you as soon as possible.'
                });
            } else {
                console.error('Error sending email.');

                addMessage({
                    error: 'An error occurred. Please try again.'
                });
            }

            setIsSending(false);
            return response.json();
        }).catch(error => {
            console.error('Error sending email:', error);

            addMessage({
                error: 'An error occurred. Please try again.'
            });

            setIsSending(false);
        });
    }

    return (
        <>
            <form onSubmit={handleSubmit} ref={formRef} id="supportForm">
                <FormFieldInput
                    label="Name"
                    fieldName="name"
                    stateObject={supportFormData}
                    updateStateObject={setSupportFormData}
                    required={true}
                />

                <FormFieldInput
                    label="Email"
                    fieldName="email"
                    stateObject={supportFormData}
                    updateStateObject={setSupportFormData}
                    required={true}
                />

                <FormFieldTextarea
                    label="Message"
                    fieldName="message"
                    stateObject={supportFormData}
                    updateStateObject={setSupportFormData}
                    required={true}
                />

                {/* ADD CAPTCHA */}

                {/* <div className="g-recaptcha" data-sitekey="your_site_key"></div> */}

                {!isSending && (
                    <button type="submit" className="button button-blue">
                        Submit
                    </button>
                )}

                {isSending && (
                    <LoadingSpinner />
                )}
            </form>
        </>
    );
}

export default SupportPHPMailer;
